'use client'

import { CollectionMixMatchV2 } from '@/components/common/collection/collection-mix-match-v2'
import { useTranslations } from 'next-intl'
import { MIX_MATCH_ITEMS, TRACKING_PREFIX } from './constants'

export function MixMatchSection() {
  const t = useTranslations('do_thu_dong_hardcode.mix_match')

  return (
    <CollectionMixMatchV2
      title={t('title')}
      data={MIX_MATCH_ITEMS}
      trackingValue={`${TRACKING_PREFIX}__mix-match`}
    />
  )
}
